import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSpaceUserAccess on SpaceUserAccess {
    id
    userId
    name
    code
    organization
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpaceUserAccessFragment,
  ents.extra.space.User.Access
>({
  code: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.User.Access.Id.isId,
  ),
  name: transformers.PASS_THROUGH,
  organization: graphql.transformers.OUT.nullable(
    graphql.transformers.OUT.validate(
      graphql.transformers.OUT.json(),
      ents.extra.space.Organization.Lookup.assertIsLookup,
    ),
  ),
  userId: transformers.PASS_THROUGH,
})
